// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabs_tabsContainer__F30_V","tabs":"tabs_tabs__tuxiy","tabsItem":"tabs_tabsItem__sPebl","isActive":"tabs_isActive__UMGAi"};